import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Wordmark, cta } from "./_shared";

export default function LandingHeader() {
  return (
    <header className="sticky top-0 z-40 bg-clinical-bg/85 backdrop-blur-md border-b border-clinical-border/40">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="landing-logo" className="flex items-center">
          <Wordmark />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-clinical-text">
          <a href="#features" className="hover:text-afyanex-blue transition">Features</a>
          <a href="#how" className="hover:text-afyanex-blue transition">How it works</a>
          <Link to="/pricing" className="hover:text-afyanex-blue transition" data-testid="landing-nav-pricing">Pricing</Link>
          <a href="#faq" className="hover:text-afyanex-blue transition">FAQ</a>
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/login"
                onClick={cta("nav", "/login")}
                className="text-sm font-medium text-clinical-text hover:text-afyanex-blue px-3 py-2 transition"
                data-testid="landing-signin-link">
            Sign in
          </Link>
          <Link to="/agency/signup"
                onClick={cta("nav", "/agency/signup")}
                className="inline-flex items-center gap-2 rounded-full bg-afyanex-blue px-4 py-2 text-sm font-semibold text-white shadow-[0_8px_24px_-12px_rgba(0,94,255,0.6)] hover:shadow-[0_10px_30px_-10px_rgba(0,94,255,0.7)] hover:-translate-y-px transition-all"
                data-testid="landing-cta-nav">
            Try live demo <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </header>
  );
}
